import { css } from 'linaria';

export const selectTintColorContainer = css`
  display: flex;
  gap: var(--space-150);

  tint-button {
    background: unset;
  }

  tint-button[disabled] {
    display: none !important;

    ~ div {
      display: none;
    }
  }
`;
